"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_1D_TICKERS = exports.ALL_DAY_TICKERS = exports.NON_REAL_MONEY_TICKERS = exports.Ticker = void 0;
// temporarily disabling crypto tickers since they require
// extra work to be able to run 24 hours
var Ticker;
(function (Ticker) {
    // Bitcoin = 'BTC/USD',
    // Ethereum = 'ETH/USD',
    Ticker["Airbnb"] = "ABNB";
    Ticker["Amazon"] = "AMZN";
    Ticker["AmcEntertainment"] = "AMC";
    Ticker["AMD"] = "AMD";
    Ticker["Apple"] = "AAPL";
    Ticker["BlackBerry"] = "BB";
    Ticker["Google"] = "GOOGL";
    Ticker["Palantir"] = "PLTR";
    Ticker["Intel"] = "INTC";
    Ticker["HP"] = "HPQ";
    Ticker["TSM"] = "TSM";
    Ticker["Alibaba"] = "BABA";
    Ticker["Visa"] = "V";
    Ticker["JohnsonNJohnson"] = "JNJ";
    Ticker["Walmart"] = "WMT";
    Ticker["Nvidia"] = "NVDA";
    Ticker["Wish"] = "WISH";
    Ticker["Nio"] = "NIO";
    Ticker["McDonalds"] = "MCD";
    Ticker["Facebook"] = "FB";
    Ticker["Netflix"] = "NFLX";
    Ticker["Salesforce"] = "CRM";
    Ticker["Disney"] = "DIS";
    Ticker["Gme"] = "GME";
    Ticker["Microsoft"] = "MSFT";
    Ticker["Moderna"] = "MRNA";
    Ticker["Pfizer"] = "PFE";
    Ticker["Snap"] = "SNAP";
    Ticker["Tesla"] = "TSLA";
    Ticker["RiotBlockchain"] = "RIOT";
    Ticker["MarathonPatentGroup"] = "MARA";
    Ticker["SOS"] = "SOS";
    Ticker["NXST"] = "NXST";
    Ticker["FUTU"] = "FUTU";
    Ticker["CELH"] = "CELH";
    Ticker["NucorCorporation"] = "NUE";
    Ticker["AI"] = "AI";
    Ticker["CLOV"] = "CLOV";
    Ticker["KO"] = "KO";
    Ticker["SHOP"] = "SHOP";
    Ticker["SOFI"] = "SOFI";
    Ticker["SPCE"] = "SPCE";
    Ticker["SPY"] = "SPY";
    // HOOD = 'HOOD',
    // ATVI = 'ATVI',
    // QCOM = 'QCOM',
    // DKNG = 'DKNG',
    // SQ = 'SQ',
    // ROKU = 'ROKU',
    // UBER = 'UBER',
    // DDOG = 'DDOG',
    // PATH = 'PATH',
    // ETSY = 'ETSY',
    // GM = 'GM',
    // GE = 'GE',
    // TLRY = 'TLRY',
    // QQQ = 'QQQ',
    // TWTR = 'TWTR',
    // RCL = 'RCL',
    // SAVE = 'SAVE',
    // UA = 'UA',
    // UAL = 'UAL',
    // NCLH = 'NCLH',
    // MAR = 'MAR',
    // ZNGA = 'ZNGA',
    // BYND = 'BYND',
    // BAC = 'BAC',
    // WFC = 'WFC',
    // Z = 'Z'
})(Ticker = exports.Ticker || (exports.Ticker = {}));
// these tickers cannot be traded using real money.
exports.NON_REAL_MONEY_TICKERS = [
// Ticker.Bitcoin,
// Ticker.Ethereum
];
// these tickers can be executed 24/7
exports.ALL_DAY_TICKERS = [
/*Ticker.Bitcoin, Ticker.Ethereum*/
];
// tickers whose 1 day graph in trading view doesn't work
exports.NON_1D_TICKERS = [
/*Ticker.Bitcoin, Ticker.Ethereum*/
];
